import React from 'react';
import { motion } from 'framer-motion';
import { workExperience } from '../data/experienceData';

const containerVariants = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0.2
    }
  }
};

const itemVariants = {
  hidden: { y: 20, opacity: 0 },
  visible: {
    y: 0,
    opacity: 1
  }
};

const Experience: React.FC = () => {
  return (
    <div className=" px-4 md:px-8 bg-black">
      <div className="max-w-7xl mx-auto">
          {/* Sight line separator */}
       <div className="border-t border-white/20 my-20"></div>
        <motion.div
          initial="hidden"
          animate="visible"
          variants={containerVariants}
          className="flex flex-col md:flex-row items-start md:items-start justify-between gap-4 md:gap-8"
        >
          <h2 className="text-lg font-bold">Work Experience</h2>

          <div className="space-y-8 md:space-y-16 w-full md:max-w-2xl">
            {workExperience.map((item, index) => (
              <motion.div
                key={index}
                className="flex flex-row items-start gap-4 md:gap-8"
                variants={itemVariants}
              >
                <div className="flex items-center w-20 md:w-40">
                  <img 
                    src={item.logoSrc} 
                    alt={item.companyName} 
                    className="h-14 md:h-16 w-auto object-contain transition-all duration-300"
                  />
                </div>
                <div className="text-left flex-1">
                  <h3 className="text-lg md:text-xl font-semibold mb-1">{item.jobTitle}</h3>
                  <p className="text-white/70 text-sm mb-1">{item.location}</p>
                  <p className="text-white/50 text-xs">{item.duration}</p>
                </div>
              </motion.div>
            ))}

            <motion.div
              className="flex items-center w-full md:w-32"
              variants={itemVariants}
            >
              <motion.a
                href="/Images/Manish_Shrestha_UXUI.pdf"
                download="Manish_Shrestha_UXUI.pdf"
                whileHover={{ scale: 1.05, boxShadow: '0 4px 24px 0 rgba(255,255,255,0.08)' }}
                transition={{ type: 'spring', stiffness: 300 }}
                className="group flex items-center gap-2 px-4 md:px-6 py-3 md:py-4 text-sm md:text-base font-medium border border-white/30 rounded-full hover:bg-white/40 transition-all duration-300 shadow-sm whitespace-nowrap w-full md:w-auto justify-center"
              >
                <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path>
                </svg>
                Download Resume
              </motion.a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default Experience;
